import React, { useRef, useState } from 'react';
import { Tooltip, Typography, TypographyProps } from '@mui/material';

interface Props extends Omit<TypographyProps, 'children' | 'noWrap'> {
  text: string;
}

export const TruncatedText = ({ text, ...typographyProps }: Props) => {
  const ref = useRef<HTMLElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    const el = ref.current;
    setOpen(!!el && el.scrollWidth >= el.clientWidth);
  };

  return (
    <Tooltip title={text} open={open} onOpen={handleOpen} onClose={() => setOpen(false)}>
      <Typography ref={ref} noWrap {...typographyProps}>
        {text}
      </Typography>
    </Tooltip>
  );
};
